import * as Yup from 'yup';
import { measurementTyes } from '../constants';

export const productValidationSchema = Yup.object().shape({
  name: Yup.string().required('The product name is required'),
  beerStyleId: Yup.number().required('The beers style is required'),
  volume: Yup.number().required('The volume is required'),
  abv: Yup.number().required('The abv value is required'),
  costPerLitre: Yup.number().required('The cost per litre value is required'),
  lotPrefix: Yup.string().required('The lot prefix is required'),
  ingredients: Yup.array().of(
    Yup.object().shape({
      ingredientId: Yup.number().required('The ingredient is required'),
      amount: Yup.number().required('The ingredient amount is required'),
      measurementType: Yup.string()
        .oneOf(measurementTyes, 'The unit of measurement is not valid')
        .required('The ingredient unit of measurement is required')
    })
  ),
  variants: Yup.array().of(
    Yup.object().shape({
      vesselTypeId: Yup.number().required('The vessel type is required'),
      name: Yup.string().required('The name is required'),
      code: Yup.string().required('The code is required')
    })
  )
});



// WEBPACK FOOTER //
// ./src/validation/product.js